declare global {
  interface Window {
    ciq?: {
      enabledFeatureFlags?: string[];
    };
  }
}

export const FEATURE_FLAG_AGENT_CHARTING = 'feature_flag_agent_charting';

export const isFeatureEnabled = (flagName: string): boolean => {
  return window.ciq?.enabledFeatureFlags?.includes(flagName) ?? false;
};
